// 中文
export const GUIDES = [
  { name: 'guide-overview', title: '功能概览', groupIndex: 0 },
  { name: 'guide-account', title: '关于账号', groupIndex: 0 },
  { name: 'guide-vehicle', title: '关于车辆', groupIndex: 0 },
  { name: 'guide-meterSetting', title: '如何进行仪表设置', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: '如何进行车辆设置', groupIndex: 1 },
  { name: 'guide-findNavigation', title: '如何导航寻车', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: '如何使用导航', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: '关于骑行记录', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: '如何进行车辆体检', groupIndex: 3 },
  { name: 'guide-useSetting', title: '如何进行APP通用设置', groupIndex: 3 },
  { name: 'guide-notice', title: '如何查看并设置消息通知', groupIndex: 3 },
  { name: 'guide-about', title: '关于APP', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO手机' },
  { icon: 'mi', name: 'mi', title: '小米手机' },
  { icon: 'huawei', name: 'huawei', title: '华为手机' },
  { icon: 'honor', name: 'honor', title: '荣耀手机' },
];

export const FEEDBACK_STATES = {
  0: '待处理',
  1: '已提交',
  2: '已回复',
  3: '沟通中',
  4: '对策中',
  5: '已解决',
};

export const FEEDBACK_TYPES = {
  1: '反馈',
  2: '回复',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
